import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private oidcSecurityService: OidcSecurityService;

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.oidcSecurityService === undefined) {
      this.oidcSecurityService = this.injector.get(OidcSecurityService);
    }
    if (this.oidcSecurityService !== undefined) {
      let token = this.oidcSecurityService.getToken();
      const stsServer = this.oidcSecurityService.configuration?.configuration?.stsServer;

      if (stsServer && !request.url.startsWith(stsServer)) {
        token = this.oidcSecurityService.getIdToken();
      }

      if (token && this.shouldAddAuthHeader(request)) {
        const tokenValue = 'Bearer ' + token;
        request = request.clone({ setHeaders: { Authorization: tokenValue } });
      }
    } else {
      console.debug('OidcSecurityService undefined: NO auth header!');
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpErrorResponse) {
          if (event.status === 401) {
            this.oidcSecurityService.authorize();
          }
        }
        return event;
      })
    );
  }

  private shouldAddAuthHeader(request: HttpRequest<any>): boolean {
    if (request.url === this.oidcSecurityService.configuration.wellknown.tokenEndpoint) {
      return false;
    }

    return true;
  }
}
